// extracted by mini-css-extract-plugin
export default {"info":"style_info__fhG2J","spinner":"style_spinner__sb7RA"};